import { usePathname, useRouter } from 'next/navigation'
import styles from './VotingButton.module.scss'
import { IVotingButton } from 'types/voting'
import { fireAnalyticsEvent } from '~analyticsUtils'

const VotingButton = ({ buttonText, buttonThumbnailImage, href, id }: IVotingButton) => {
  const { push } = useRouter()
  const pathname = usePathname() || ''
  const linkModule = 'xo_landing_page'

  const handleButtonClick = () => {
    fireAnalyticsEvent(null, pathname, {
      clickTracking: `xo_landing_page:${buttonText}:cta`,
      clickType: 'cta',
      linkModule: linkModule
    })

    const basePath = pathname.substring(0, pathname.lastIndexOf('/'))
    const newPath = `${basePath}/${href}`
    push(newPath)
  }

  return (
    <button className={styles['voting-button']} onClick={handleButtonClick} key={id}>
      {buttonThumbnailImage && <img src={buttonThumbnailImage.url} />}
      <div className={styles['gradient-layer']}></div>
      <div className={styles['opacity-layer']}></div>
      <span>{buttonText}</span>
    </button>
  )
}

export default VotingButton
